Ext.define('SA.view.sidebar.data.DatasetsList', {
    alias: 'widget.datasets-list',
    extend: 'Ext.Component',

    cls: 'sa-datasets-list',

    tpl: [
        '<tpl for=".">',
            '<div class="sa-datasets-list-item<tpl if="selected"> sa-datasets-list-item-selected</tpl>" data-dataset-id="{id:htmlEncode}">',
                '<svg class="sa-datasets-list-item-icon sa-datasets-list-item-icon-closed"><use href="#sa-icon-folder-closed"></use></svg>',
                '<svg class="sa-datasets-list-item-icon sa-datasets-list-item-icon-open"><use href="#sa-icon-folder-open"></use></svg>',
                '<div class="sa-datasets-list-item-name">{name:htmlEncode}</div>',
            '</div>',
        '</tpl>'
    ],

    initEvents() {
        this.callParent();

        this.getEl().on('click', this.onClickItem, this, {delegate: '.sa-datasets-list-item'});
    },

    onClickItem(ev) {
        var item = ev.getTarget(),
            dataset = item.getAttribute('data-dataset-id');

        if (!item.classList.contains('sa-datasets-list-item-selected')) {
            this.fireEvent('select', this, dataset);
        }
    },

    refresh() {
        this.update(this.datasets.map(id => ({
            id,
            name: SA.data.Datasets.getName(id),
            selected: id === this.selected
        })));
    },

    setDatasets(datasets) {
        this.datasets = datasets;

        this.refresh();
    },

    setSelected(selected) {
        this.selected = selected;

        this.refresh();
    }
});